import { createAnalogInput, createAnalogOutput, createCalibrationTable, createModBusSignal, createOutputAction, createUIGroup, createWebElement, createWiredTemperatureSensor, } from './create-objects';
import { AnalogInput, ModBusSignal } from 'z3k-config';
export var ModBusDevicesName;
(function (ModBusDevicesName) {
    ModBusDevicesName["MB10TD"] = "MB10TD";
    ModBusDevicesName["MB110"] = "MB110";
    ModBusDevicesName["MK110"] = "MK110";
    ModBusDevicesName["R46CA01"] = "R46CA01";
    ModBusDevicesName["R413D08"] = "R413D08";
    ModBusDevicesName["ESQ210"] = "ESQ210";
    ModBusDevicesName["TPM210"] = "TPM210";
    ModBusDevicesName["DT130"] = "DT130";
    ModBusDevicesName["TPM1033"] = "TPM1033";
    ModBusDevicesName["MU110_224_6_U"] = "MU110_224_6_U";
    ModBusDevicesName["SYNERGY"] = "SYNERGY";
    ModBusDevicesName["SDM230"] = "SDM230";
})(ModBusDevicesName || (ModBusDevicesName = {}));
export const modBusConfigs = {
    [ModBusDevicesName.MB10TD]: {
        name: 'Модуль термодатчиков 1-wire MB10TD',
        config: {
            modbus_signals: [
                createModBusSignal({
                    id: 8001,
                    name: 'Датчики температуры',
                    address: 5,
                    buffer_length: 160,
                    var_count: 10,
                    var_length: 16,
                    var_period_repeat: 16,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                }),
            ],
        },
    },
    [ModBusDevicesName.MB110]: {
        name: 'Модуль аналогового ввода ОВЕН МВ110-224.8А',
        config: {
            modbus_signals: [
                createModBusSignal({
                    id: 8001,
                    name: 'Вход 1',
                    address: 30001,
                    buffer_length: 16,
                    var_length: 16,
                    var_period_repeat: 0,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                }),
                createModBusSignal({
                    id: 8002,
                    name: 'Вход 2',
                    address: 30007,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8003,
                    name: 'Вход 3',
                    address: 30013,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8004,
                    name: 'Вход 4',
                    address: 30019,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8005,
                    name: 'Вход 5',
                    address: 30025,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8006,
                    name: 'Вход 6',
                    address: 30031,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8007,
                    name: 'Вход 7',
                    address: 30037,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8008,
                    name: 'Вход 8',
                    address: 30043,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
        },
    },
    [ModBusDevicesName.MK110]: {
        name: 'Модуль цифрового ввода/вывода МК110-224.8Д.4Р',
        config: {
            modbus_signals: [
                createModBusSignal({
                    id: 8001,
                    name: 'Дискретные входы',
                    address: 30051,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 8,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8002,
                    name: 'Дискретные выходы',
                    address: 30050,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 4,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
        },
    },
    [ModBusDevicesName.R46CA01]: {
        name: 'Китайский датчик температуры R46CA01',
        config: {
            wired_temperature_sensors: [
                createWiredTemperatureSensor({
                    id: 8001,
                    serial: '0',
                    name: 'Температура R46CA01',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 1.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8002,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8002,
                    name: 'Знач. темп.',
                    address: 40000,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
        },
    },
    [ModBusDevicesName.R413D08]: {
        name: 'Китайский модуль реле R413D08',
        config: {
            output_actions: [
                createOutputAction({
                    id: 8001,
                    name: 'Вкл. вых. №1 R413D08',
                    physical_output: 128192,
                    action: {
                        type: 42,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 256,
                }),
                createOutputAction({
                    id: 8002,
                    name: 'Выкл. вых. №1 R413D08',
                    physical_output: 128192,
                    action: {
                        type: 42,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 512,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8003,
                    name: 'Рег. вых. №1 R413D08',
                    address: 40001,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8004,
                    name: 'Рег. вых. №2 R413D08',
                    address: 40002,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8005,
                    name: 'Рег. вых. №3 R413D08',
                    address: 40003,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8006,
                    name: 'Рег. вых. №4 R413D08',
                    address: 40004,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8007,
                    name: 'Рег. вых. №5 R413D08',
                    address: 40005,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8008,
                    name: 'Рег. вых. №6 R413D08',
                    address: 40006,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8009,
                    name: 'Рег. вых. №7 R413D08',
                    address: 40007,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8010,
                    name: 'Рег. вых. №8 R413D08',
                    address: 40008,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8011,
                    name: 'Вых №1 чт.',
                    address: 40001,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 8012,
                    name: 'Выход №1 R413D08',
                    min_value: 256,
                    max_value: 512,
                    step: 1,
                    unit: 0,
                    mult: 1,
                    setting_register: 0,
                    physical_output: 128048,
                }),
            ],
        },
    },
    [ModBusDevicesName.ESQ210]: {
        name: 'Частотные преобразователи INNOVERT IDD, esq-210',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 9080,
                    physical_input_num: 134208,
                    name: 'Тек. част. пр.',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 9079,
                    position: 0,
                    units: 8,
                }),
            ],
            output_actions: [
                createOutputAction({
                    id: 8687,
                    name: 'Старт. част. пр.',
                    physical_output: 137200,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 2,
                }),
                createOutputAction({
                    id: 8688,
                    name: 'Стоп. част. пр.',
                    physical_output: 137200,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 1,
                }),
            ],
            web_elements: [
                createWebElement({
                    id: 8756,
                    name: 'Старт/стоп част. пр..',
                    type: 2,
                    label1: 'Выкл.част. пр.',
                    label2: 'Вкл.част пр.',
                    setting_register: 8,
                    id_active: 8687,
                    id_passive: 8688,
                    position: 1,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8542,
                    name: 'Частота на вых пр.',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8509,
                    id_passive: null,
                    position: 2,
                    alice_view: 0,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8242,
                    name: 'RUN/STOP2',
                    address: 48192,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8275,
                    name: 'Set частоты2',
                    address: 48193,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8388,
                    name: 'Текущая частота',
                    address: 40002,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 8509,
                    name: 'Уст частоты част. пр.',
                    min_value: 0,
                    max_value: 600,
                    step: 1,
                    unit: 1,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 132400,
                }),
                createAnalogOutput({
                    id: 8575,
                    name: 'RUN/STOP част. пр.',
                    min_value: 1,
                    max_value: 2,
                    step: 1,
                    unit: 0,
                    mult: 1,
                    setting_register: 0,
                    physical_output: 131872,
                }),
            ],
        },
    },
    [ModBusDevicesName.TPM210]: {
        name: 'ТРМ210',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 11814,
                    physical_input_num: 188960,
                    name: 'Стар/Стоп ТРМ210',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11813,
                    position: 0,
                    units: 8,
                }),
            ],
            wired_temperature_sensors: [
                createWiredTemperatureSensor({
                    id: 11352,
                    serial: '0',
                    name: 'Текущая ТРМ210',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 11287,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 11385,
                    serial: '0',
                    name: 'Уставка ТРМ210',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 10771,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
            ],
            output_actions: [
                createOutputAction({
                    id: 12142,
                    name: 'Старт ТРМ210',
                    physical_output: 189552,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 1,
                }),
                createOutputAction({
                    id: 12143,
                    name: 'Стоп ТРМ 210',
                    physical_output: 189552,
                    action: {
                        type: 0,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 0,
                }),
            ],
            web_elements: [
                createWebElement({
                    id: 12176,
                    name: 'Старт/Стоп ТРМ210',
                    type: 2,
                    label1: 'Стоп ТРМ210',
                    label2: 'Старт ТРМ210',
                    setting_register: 0,
                    id_active: 12142,
                    id_passive: 12143,
                    position: 3,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 11615,
                    name: 'Уставка ТРМ210',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 11582,
                    id_passive: null,
                    position: 4,
                    alice_view: 0,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 10771,
                    name: 'SP (Уставка t rd)',
                    address: 40002,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.RESISTANCE_THERMOMETER,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11287,
                    name: 'PV (текущая t)',
                    address: 40001,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.RESISTANCE_THERMOMETER,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11450,
                    name: 'O (положение заслонок)',
                    address: 40004,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11517,
                    name: 'SP (Уставка t wr)',
                    address: 30002,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 1,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11810,
                    name: 'R-S (Стар/Стоп rd)',
                    address: 40007,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.DISCRETE_INPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11847,
                    name: 'R-S (Стар/Стоп wr)',
                    address: 30007,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 2,
                    type: ModBusSignal.Type.DISCRETE_OUTPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 11582,
                    name: 'Уставка ТРМ210',
                    min_value: 10,
                    max_value: 300,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 184272,
                }),
            ],
        },
    },
    [ModBusDevicesName.DT130]: {
        name: 'Котел DeDietrich c modbus DTG 130 Diematic 3 GT 220 Diematic 3',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 8236,
                    physical_input_num: 131728,
                    name: 'Общее число устройств на шине',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8235,
                    position: 0,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8238,
                    physical_input_num: 131744,
                    name: 'Номер версии EEPROM',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8237,
                    position: 0,
                    units: 8,
                }),
            ],
            wired_temperature_sensors: [
                createWiredTemperatureSensor({
                    id: 8209,
                    serial: '0',
                    name: 'Т. наружная',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8221,
                    recovery_list: [],
                    setting_register: 0,
                    position: 1,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8222,
                    serial: '0',
                    name: 'Т. к.А день',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8220,
                    recovery_list: [],
                    setting_register: 0,
                    position: 2,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8223,
                    serial: '0',
                    name: 'Т. к.А ночь',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8219,
                    recovery_list: [],
                    setting_register: 0,
                    position: 3,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8240,
                    serial: '0',
                    name: 'Т. в помещении',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8239,
                    recovery_list: [],
                    setting_register: 0,
                    position: 4,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8257,
                    serial: '0',
                    name: 'Т. к.B день',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8249,
                    recovery_list: [],
                    setting_register: 0,
                    position: 5,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8258,
                    serial: '0',
                    name: 'Т. к.B ночь',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8250,
                    recovery_list: [],
                    setting_register: 0,
                    position: 6,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8259,
                    serial: '0',
                    name: 'Т. в помещении',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8251,
                    recovery_list: [],
                    setting_register: 0,
                    position: 7,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8260,
                    serial: '0',
                    name: 'Т. подачи к. В',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8252,
                    recovery_list: [],
                    setting_register: 0,
                    position: 8,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8261,
                    serial: '0',
                    name: 'Т. к.C день',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8253,
                    recovery_list: [],
                    setting_register: 0,
                    position: 9,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8262,
                    serial: '0',
                    name: 'Т. к.C ночь',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8254,
                    recovery_list: [],
                    setting_register: 0,
                    position: 10,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8263,
                    serial: '0',
                    name: 'Т. в помещении',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8255,
                    recovery_list: [],
                    setting_register: 0,
                    position: 11,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8264,
                    serial: '0',
                    name: 'Т. подачи к. C',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8256,
                    recovery_list: [],
                    setting_register: 0,
                    position: 12,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8242,
                    serial: '0',
                    name: 'Т. гор. воды и.',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8241,
                    recovery_list: [],
                    setting_register: 1024,
                    position: 13,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8244,
                    serial: '0',
                    name: 'Т. котла',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8243,
                    recovery_list: [],
                    setting_register: 0,
                    position: 14,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8246,
                    serial: '0',
                    name: 'Т. ГВС зад. но ',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8245,
                    recovery_list: [],
                    setting_register: 0,
                    position: 15,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8248,
                    serial: '0',
                    name: 'Т. ГВС зад. де. ',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8307,
                    recovery_list: [],
                    setting_register: 0,
                    position: 16,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8308,
                    serial: '0',
                    name: 'Регистр №59',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8307,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
            ],
            web_elements: [
                createWebElement({
                    id: 8265,
                    name: 'Температура дневная А',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8230,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8266,
                    name: 'Ночная температура А',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8231,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8285,
                    name: 'Температура дневная B',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8279,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8286,
                    name: 'Ночная температура B',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8280,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8287,
                    name: 'Температура дневная С',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8281,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8288,
                    name: 'Ночная температура C',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8282,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8289,
                    name: 'Ночная т. воды в водонагр.',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 0,
                    id_active: 8283,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8290,
                    name: 'Заданное значение воды для ГВС',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8284,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
            ],
            ui_groups: [
                createUIGroup({
                    id: 8268,
                    name: 'Контур А',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 11,
                    items: [8222, 8223, 8240, 8265, 8266],
                    position: 1,
                }),
                createUIGroup({
                    id: 8269,
                    name: 'Контур B',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 11,
                    items: [8257, 8258, 8259, 8260, 8285, 8286],
                    position: 2,
                }),
                createUIGroup({
                    id: 8270,
                    name: 'Контур С',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 11,
                    items: [8261, 8262, 8263, 8264, 8287, 8288],
                    position: 3,
                }),
                createUIGroup({
                    id: 8272,
                    name: 'ГВС',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 4,
                    items: [8246, 8248, 8242, 8289, 8290],
                    position: 4,
                }),
                createUIGroup({
                    id: 8271,
                    name: 'Котел',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 10,
                    items: [8238, 8236, 8244],
                    position: 5,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8219,
                    name: 'Рег. №15 чт.',
                    address: 30015,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8220,
                    name: 'Рег. №14 чт.',
                    address: 30014,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8221,
                    name: 'Рег. №7',
                    address: 30007,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8225,
                    name: 'Рег. №14 зп.',
                    address: 30014,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8226,
                    name: 'Рег. №15 зп.',
                    address: 30015,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8233,
                    name: 'Рег. №2',
                    address: 30002,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8234,
                    name: 'Рег. №3',
                    address: 30003,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.UNIFIED_SIGNAL,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8239,
                    name: 'Рег. №18',
                    address: 30018,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8241,
                    name: 'Рег. №62',
                    address: 30062,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8243,
                    name: 'Рег. №75',
                    address: 30075,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8245,
                    name: 'Рег. №96',
                    address: 30096,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8247,
                    name: 'Рег. №121',
                    address: 30121,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8249,
                    name: 'Рег. №23 чт.',
                    address: 30023,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8250,
                    name: 'Рег. №24 чт.',
                    address: 30024,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8251,
                    name: 'Рег. №27',
                    address: 30027,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8252,
                    name: 'Рег. №33',
                    address: 30033,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8253,
                    name: 'Рег. №35',
                    address: 30035,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8254,
                    name: 'Рег. №36',
                    address: 30036,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8255,
                    name: 'Рег. №39',
                    address: 30039,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8256,
                    name: 'Рег. №45',
                    address: 30045,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 8,
                    setting_register: 1,
                    type: ModBusSignal.Type.ONE_WIRE,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8273,
                    name: 'Рег. №23 зп.',
                    address: 30023,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8274,
                    name: 'Рег. №24 зп.',
                    address: 30024,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8275,
                    name: 'Рег. №35 зп.',
                    address: 30035,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8276,
                    name: 'Рег. №36 зп.',
                    address: 30036,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8277,
                    name: 'Рег. №96 зп.',
                    address: 30096,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8278,
                    name: 'Рег. №121 зп.',
                    address: 30121,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8307,
                    name: 'Рег. №59 чт.',
                    address: 30059,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.RESISTANCE_THERMOMETER,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8310,
                    name: 'Рег. №59 зп.',
                    address: 30059,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 8230,
                    name: 'Дневная температура к. А',
                    min_value: 100,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 131600,
                }),
                createAnalogOutput({
                    id: 8231,
                    name: 'Ночная температура к. А',
                    min_value: 50,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 131616,
                }),
                createAnalogOutput({
                    id: 8279,
                    name: 'Дневная температура к. B',
                    min_value: 100,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132368,
                }),
                createAnalogOutput({
                    id: 8280,
                    name: 'Ночная температура к. B',
                    min_value: 50,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132384,
                }),
                createAnalogOutput({
                    id: 8281,
                    name: 'Дневная температура к. C',
                    min_value: 100,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132400,
                }),
                createAnalogOutput({
                    id: 8282,
                    name: 'Ночная температура к. C',
                    min_value: 50,
                    max_value: 300,
                    step: 5,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132416,
                }),
                createAnalogOutput({
                    id: 8283,
                    name: 'Ночная т. в водонагрев.',
                    min_value: 100,
                    max_value: 800,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132432,
                }),
                createAnalogOutput({
                    id: 8284,
                    name: 'зад. знач. темп. воды в гвс',
                    min_value: 100,
                    max_value: 800,
                    step: 10,
                    unit: 2,
                    mult: 10,
                    setting_register: 1,
                    physical_output: 132960,
                }),
            ],
        },
    },
    [ModBusDevicesName.TPM1033]: {
        name: 'Контроллер ОВЕН ТРМ1033',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 8567,
                    physical_input_num: 136960,
                    name: 'Реж. работы ТРМ',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8566,
                    position: 0,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8599,
                    physical_input_num: 136704,
                    name: 'УстТемпПритВоздНочь',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8598,
                    position: 0,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8601,
                    physical_input_num: 136736,
                    name: 'УстТемпВоздВПом',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8600,
                    position: 0,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8607,
                    physical_input_num: 137680,
                    name: 'Аварии',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8606,
                    position: 0,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8237,
                    physical_input_num: 136496,
                    name: 'УстТемпПритВозд',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8236,
                    position: 0,
                    units: 8,
                }),
            ],
            output_actions: [
                createOutputAction({
                    id: 8571,
                    name: 'Перейти в режим Старт',
                    physical_output: 136976,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 0,
                }),
                createOutputAction({
                    id: 8572,
                    name: 'Перейти в режим Стоп',
                    physical_output: 136992,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 0,
                }),
                createOutputAction({
                    id: 8608,
                    name: 'СбросАварии',
                    physical_output: 136978,
                    action: {
                        type: 1,
                        duration: 0.5,
                    },
                    turn_on_delay: 0.0,
                    blink_pulses_len: 0.0,
                    lower_priority_actions_output_list: [],
                    timetable: {
                        checked: false,
                        weekday_register: 0,
                        time: 0,
                    },
                    blink_pulses_period: 0.0,
                    analog_value: 0,
                }),
            ],
            web_elements: [
                createWebElement({
                    id: 8535,
                    name: 'УстТемпПритВозд',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 0,
                    id_active: 8536,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8573,
                    name: 'Старт ТРМ1033',
                    type: 1,
                    label1: 'Старт ТРМ1033',
                    label2: '',
                    setting_register: 0,
                    id_active: 8571,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8574,
                    name: 'Стоп ТРМ1033',
                    type: 1,
                    label1: 'Стоп ТРМ1033',
                    label2: '',
                    setting_register: 0,
                    id_active: 8572,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8593,
                    name: 'УстТемпПритВоздНочь',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8590,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8594,
                    name: 'УстТемпВоздВПом',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8591,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8595,
                    name: 'УстТемпНарВоздДляСмСезона',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 8,
                    id_active: 8592,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8603,
                    name: 'Элемент управления',
                    type: 0,
                    label1: 'Вкл',
                    label2: 'Выкл',
                    setting_register: 0,
                    id_active: 8567,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
                createWebElement({
                    id: 8609,
                    name: 'Сброс Аварии',
                    type: 1,
                    label1: 'Сброс Аварии',
                    label2: '',
                    setting_register: 0,
                    id_active: 8608,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
            ],
            calibration_tables: [
                createCalibrationTable({
                    id: 8566,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 8598,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 8600,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 8606,
                    table: [],
                    multiply_x: 10,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8480,
                    name: 'УстТемпПритВоздЗп',
                    address: 30546,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8531,
                    name: 'УстТемпПритВоздЧт',
                    address: 30546,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8543,
                    name: 'УстТПритВоздНочьЗп',
                    address: 30548,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8544,
                    name: 'УстТПритВоздНочьЧт',
                    address: 30548,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8545,
                    name: 'УстТВоздВПомЗп',
                    address: 30550,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8546,
                    name: 'УстТВоздВПомЧт',
                    address: 30550,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8547,
                    name: 'УстТНарВоздДляСмСезонаЗп',
                    address: 30554,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8552,
                    name: 'УстТНарВоздДляСмСезонаЧт',
                    address: 30554,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8556,
                    name: 'ТНарВозд',
                    address: 30516,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8557,
                    name: 'ТПритВозд',
                    address: 30518,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8559,
                    name: 'ТВоздВПом',
                    address: 30522,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8560,
                    name: 'РежРаботы',
                    address: 30534,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8561,
                    name: 'РегУпрСтарт',
                    address: 30532,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 4,
                    var_length: 1,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.DISCRETE_OUTPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8562,
                    name: 'РегУпрСтоп',
                    address: 30533,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 1,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.DISCRETE_OUTPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8605,
                    name: 'РегАварии',
                    address: 30544,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 8536,
                    name: 'УстТемпПритВозд',
                    min_value: 0,
                    max_value: 990,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 135680,
                }),
                createAnalogOutput({
                    id: 8590,
                    name: 'УстТемпПритВоздНочь',
                    min_value: 0,
                    max_value: 990,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 136688,
                }),
                createAnalogOutput({
                    id: 8591,
                    name: 'УстТемпВоздВПом',
                    min_value: 0,
                    max_value: 990,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 136720,
                }),
                createAnalogOutput({
                    id: 8592,
                    name: 'УстТемпНарВоздДляСмСезона',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 2,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 136752,
                }),
            ],
            wired_temperature_sensors: [
                createWiredTemperatureSensor({
                    id: 8615,
                    serial: '0',
                    name: 'ТемпПритВозд',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8557,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8616,
                    serial: '0',
                    name: 'ТемпНарВозд',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8556,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8619,
                    serial: '0',
                    name: 'ТемпВоздВПом',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5.0,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8559,
                    recovery_list: [],
                    setting_register: 0,
                    position: 0,
                    calibration_shift: 0,
                }),
            ],
        },
    },
    [ModBusDevicesName.MU110_224_6_U]: {
        name: 'Модуль аналогового вывода ОВЕН МУ110-224.6У',
        config: {
            web_elements: [
                createWebElement({
                    id: 8644,
                    name: 'Значение на аналоговом вых №1',
                    type: 3,
                    label1: '',
                    label2: '',
                    setting_register: 0,
                    id_active: 8637,
                    id_passive: null,
                    position: 0,
                    alice_view: 0,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8635,
                    name: 'Рег. Аналог. Вых',
                    address: 5,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 6,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 2,
                    type: ModBusSignal.Type.ANALOG_OUTPUT_UINT16,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8636,
                    name: 'Авар. Знач. На вых',
                    address: 30016,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
            analog_outputs: [
                createAnalogOutput({
                    id: 8637,
                    name: 'Аналоговый Вых МУ№1',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138160,
                }),
                createAnalogOutput({
                    id: 8657,
                    name: 'Аналоговый Вых МУ№2',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138161,
                }),
                createAnalogOutput({
                    id: 8658,
                    name: 'Аналоговый Вых МУ№3',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138162,
                }),
                createAnalogOutput({
                    id: 8659,
                    name: 'Аналоговый Вых МУ№4',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138163,
                }),
                createAnalogOutput({
                    id: 8660,
                    name: 'Аналоговый Вых МУ№5',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138164,
                }),
                createAnalogOutput({
                    id: 8661,
                    name: 'Аналоговый Вых МУ№6',
                    min_value: 0,
                    max_value: 1000,
                    step: 1,
                    unit: 0,
                    mult: 10,
                    setting_register: 0,
                    physical_output: 138165,
                }),
            ],
        },
    },
    [ModBusDevicesName.SYNERGY]: {
        name: 'Котел SYNERGY',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 8286,
                    physical_input_num: 132432,
                    name: 'Котел 1 заданная температура',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8285,
                    position: 1,
                    units: 8,
                }),
                createAnalogInput({
                    id: 8383,
                    physical_input_num: 133584,
                    name: 'Котел 1 заданная скорость',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 8382,
                    position: 2,
                    units: 8,
                }),
            ],
            wired_temperature_sensors: [
                createWiredTemperatureSensor({
                    id: 8336,
                    serial: '0',
                    name: 'Котел 1 Т1',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8219,
                    recovery_list: [],
                    setting_register: 14,
                    position: 0,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8371,
                    serial: '0',
                    name: 'Котел 1 Т2',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8250,
                    recovery_list: [],
                    setting_register: 34,
                    position: 0,
                    calibration_shift: 0,
                }),
                createWiredTemperatureSensor({
                    id: 8372,
                    serial: '0',
                    name: 'Котел 1 уходящие газы',
                    upper_threshold: null,
                    lower_threshold: null,
                    hysteresis: 0.0,
                    no_connection_timeout: 5,
                    rol_connection_lost: [],
                    rol_temperature_upper_threshold: [],
                    rol_temperature_lower_threshold: [],
                    io_extension_id: 8234,
                    recovery_list: [],
                    setting_register: 54,
                    position: 0,
                    calibration_shift: 0,
                }),
            ],
            calibration_tables: [
                createCalibrationTable({
                    id: 8285,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 8382,
                    table: [],
                    multiply_x: 10,
                }),
            ],
            ui_groups: [
                createUIGroup({
                    id: 8258,
                    name: 'Котел 1',
                    is_hidden: false,
                    hide_titles: false,
                    icon: 10,
                    items: [8336, 8371, 8372, 8286, 8383],
                    position: 0,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 8219,
                    name: 'Датчик Т1',
                    address: 30512,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8234,
                    name: 'Датчик уходящих газов',
                    address: 30514,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8250,
                    name: 'Датчик Т2',
                    address: 30516,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.THERMAL_SENSOR_FLOAT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8277,
                    name: 'Заданная температура на котле',
                    address: 30524,
                    buffer_length: 16,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8349,
                    name: 'Скорость подачи топлива',
                    address: 30522,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 16,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.INT16_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8350,
                    name: 'Входы',
                    address: 30520,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 8,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.DISCRETE_INPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 8351,
                    name: 'Выходы',
                    address: 30521,
                    buffer_length: 0,
                    buffer_offset: 0,
                    var_count: 8,
                    var_length: 1,
                    var_period_repeat: 1,
                    setting_register: 1,
                    type: ModBusSignal.Type.DISCRETE_INPUT,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
        },
    },
    [ModBusDevicesName.SDM230]: {
        name: 'Счётчик SDM230',
        config: {
            analog_inputs: [
                createAnalogInput({
                    id: 8943,
                    physical_input_num: 175104,
                    name: 'Напряжение',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11001,
                    position: 0,
                    units: AnalogInput.Units.VOLTAGE,
                }),
                createAnalogInput({
                    id: 11028,
                    physical_input_num: 176416,
                    name: 'Ток',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11027,
                    position: 0,
                    units: AnalogInput.Units.AMPER,
                }),
                createAnalogInput({
                    id: 11042,
                    physical_input_num: 176640,
                    name: 'Частота',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11041,
                    position: 0,
                    units: AnalogInput.Units.FREQUENCY,
                }),
                createAnalogInput({
                    id: 11058,
                    physical_input_num: 176864,
                    name: 'Полная мощность',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11057,
                    position: 0,
                    units: AnalogInput.Units.FULL_POWER,
                }),
                createAnalogInput({
                    id: 11060,
                    physical_input_num: 176880,
                    name: 'Активная мощность',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11059,
                    position: 0,
                    units: AnalogInput.Units.ACTIVE_POWER,
                }),
                createAnalogInput({
                    id: 11062,
                    physical_input_num: 176896,
                    name: 'Потребленная энергия',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11061,
                    position: 0,
                    units: AnalogInput.Units.ENERGY,
                }),
                createAnalogInput({
                    id: 11110,
                    physical_input_num: 177552,
                    name: 'Сдвиг фазы',
                    upper_threshold: 0.0,
                    lower_threshold: 0.0,
                    active_level_timeout: 1.0,
                    inactive_level_timeout: 2.0,
                    setting_register: 0,
                    notification_list: [],
                    sensor_type: 0,
                    recovery_list: [],
                    upper_notification_list: [],
                    impulse_frequency: 1,
                    calibration: 11109,
                    position: 0,
                    units: AnalogInput.Units.PHASE_SHIFT,
                }),
            ],
            calibration_tables: [
                createCalibrationTable({
                    id: 11001,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11027,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11041,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11057,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11059,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11061,
                    table: [],
                    multiply_x: 10,
                }),
                createCalibrationTable({
                    id: 11109,
                    table: [],
                    multiply_x: 10,
                }),
            ],
            modbus_signals: [
                createModBusSignal({
                    id: 10944,
                    name: 'Напряжение',
                    address: 30000,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11026,
                    name: 'Ток',
                    address: 30006,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11040,
                    name: 'Частота',
                    address: 30070,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11054,
                    name: 'Полная мощность',
                    address: 30018,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11055,
                    name: 'Активная мощность',
                    address: 30012,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11056,
                    name: 'Потребленная энергия',
                    address: 30342,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
                createModBusSignal({
                    id: 11097,
                    name: 'Сдвиг фазы',
                    address: 30036,
                    buffer_length: 32,
                    buffer_offset: 0,
                    var_count: 1,
                    var_length: 32,
                    var_period_repeat: 0,
                    setting_register: 1,
                    type: ModBusSignal.Type.FLOAT32_TYPE2_PARAM,
                    register_type: ModBusSignal.RegisterType.OLD_FORMAT,
                }),
            ],
        },
    },
};
